import actions from '../actions';
import constants from '../constants';
import actionTypes from '../constants/action-types';
import customization from '../../customization';
import siteLocales from '../../site-locales';

const { DEFAULT_SITE_PROGRESS_CHECKLIST } = constants;

const siteLoader = (store) => (next) => async (action) => {
  switch (action.type) {
    case actionTypes.RELOAD_SITE_META:
    case actionTypes.CONNECT_SITE: {
      const { site } = action.payload;
      const siteProperties = {
        ...site.properties,
        siteProgressChecklist:
          site.properties.siteProgressChecklist || DEFAULT_SITE_PROGRESS_CHECKLIST,
      };

      store.dispatch(siteLocales.actions.clearGlobalsHtml());
      store.dispatch(actions.setSiteId(site));
      store.dispatch(actions.setSession(site));

      store.dispatch(actions.setSettings(site.meta.settings));
      store.dispatch(actions.setRedirects(site.meta.redirects));
      store.dispatch(actions.setIntegrations(site.meta.integrations));

      store.dispatch(customization.actions.setSiteCustomization(site.meta.customization));
      store.dispatch(customization.actions.setCurrentTheme(site.meta.currentTheme));
      store.dispatch(actions.setSiteProperties(siteProperties));
      store.dispatch(actions.setOwnerId(site.ownerId));

      store.dispatch(siteLocales.actions.setMainLocale(site.meta.mainLocale));
      store.dispatch(actions.setMultilingual(site.meta.multilingual));
      store.dispatch(actions.setUpdatedAt(site.updatedAt));
      store.dispatch(actions.setLastAppliedMigrationId(site.lastAppliedMigrationId));

      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default siteLoader;
